import { createTelemetryAPI } from '~/utils/telemetry'

export const navbarTelemetry = createTelemetryAPI(({ track }) => ({
  clickLogo() {
    return track('Nav Bar: Click Logo')
  },
  clickAvatar() {
    return track('Nav Bar: Click Avatar')
  },
  clickAvatarMenuItem(item_name: 'profile' | 'logout') {
    return track('Nav Bar: Click Avatar Menu Item', { item_name })
  },
  clickSwitchOrgs() {
    return track('Nav Bar: Click Switch Orgs')
  },
  clickMenuItem(name: string) {
    return track('Nav Bar: Click Menu Item', { name })
  },
  clickTaskList() {
    return track('Nav Bar: Click Task List')
  },
  clickDocs() {
    return track('Nav Bar: Click Docs')
  },
  clickQuickLinks(link: string) {
    return track('Nav Bar: Click Quick Link', { link })
  }
}))
